import { FC } from 'react';
import Modal from '../../../../components/UI/Modals/Modal';

import classes from './ViewServiceModal.module.css';
import { IOtherService } from '../AdditionalServicesTab';
import { useTranslation } from '../../../../hooks/useTranslations';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  serviceSelected: IOtherService | null;
}

const ViewServiceModal: FC<Props> = ({ isOpen, onClose, serviceSelected }) => {
  const { translations } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton={false}
      containerPadding="30px"
      header={translations('view')}
      width="85%"
      maxWidth="800px"
      // headerStyles={{
      //   textAlign: 'center',
      //   fontSize: 20,
      //   fontWeight: 600,
      //   color: 'rgba(31, 31, 31, 1)',
      // }}
    >
      <div className={classes.container}>
        <div className={classes.serviceInfoContainer}>
          <div className={classes.serviceLabel}>{translations('service')}</div>
          <div className={classes.serviceName}>
            <span>#{serviceSelected?.service_id} </span>- {serviceSelected?.service_name ?? ''}
          </div>
        </div>
        <div className={classes.remarksContainer}>
          <div className={classes.remarksLabel}>{translations('remarks')}</div>
          <textarea
            className={classes.remarksTextArea}
            disabled={true}
            value={serviceSelected?.remarks ?? ''}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ViewServiceModal;
